import React, {useEffect, useContext, useState} from 'react';
import L from 'leaflet'
import "leaflet.vectorgrid"
import { useMap } from 'react-leaflet';
import { Context } from '../store/reducer';
import Popup93 from "./Spot/menu/popup93";

/**
 * 各種法令の規制情報_建築基準法（指定道路図）用のvector表示
 * @param id
 * @param url
 * @param layerName
 * @param color
 * @param opacity
 * @param borderColor
 * @returns {null}
 * @constructor
 */
const VectorGrid = ({id, url, layerName, color, opacity, borderColor}) => {
    const map = useMap()
    const { state, dispatch } = useContext(Context);

    const [showPopup, setShowPopup ]= useState(false);
    const [lat, setLat] = useState();
    const [lng, setLng] = useState();

    const styleOptions = {
        color: borderColor,// 線
        opacity: state.opacity,
        fill: true,
        fillColor: color,
        fillOpacity: state.opacity
    }
    
    useEffect(() => {
        
        const vectorGrid = L.vectorGrid.protobuf(url, {
            interactive: true,
            vectorTileLayerStyles: {
                [layerName]: function(properties, i){
                    return styleOptions
                }
            },
        })

        vectorGrid.on('click', function(e) {
            setLat(e.latlng.lat)
            setLng(e.latlng.lng)
            setShowPopup(true)
        });
        
        vectorGrid.addTo(map)

        return () => vectorGrid.remove()
    }, [state.opacity])
    
    return (showPopup ? <Popup93
      id={id}
      latitude={lat}
      longitude={lng}
    /> : null)
}

export default VectorGrid
